var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "addevaluatorsMain" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-8" },
        [_c("page-header", { attrs: { page: _vm.page } })],
        1
      ),
      _c("div", { staticClass: "col-4" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c(
              "action-button",
              {
                attrs: {
                  i: "fas fa-arrow-circle-left",
                  variant: "success m-2"
                },
                on: { click: _vm.goBack }
              },
              [_vm._v(" Regresar ")]
            ),
            _vm.previewListProposalAssignedToEvaluators.length > 0 &&
            _vm.canBeAssignedToEvaluators
              ? _c(
                  "action-button",
                  {
                    attrs: {
                      i: "fas fa-chevron-circle-right",
                      variant: "success m-2"
                    },
                    on: { click: _vm.assignProposalsToEvaluatorsHandler }
                  },
                  [_vm._v(" Continuar ")]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [_c("custom-separator", { attrs: { text: _vm.page.separatorTitle } })],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 mt-2" },
        _vm._l(_vm.previewListProposalAssignedToEvaluators, function(
          item,
          index
        ) {
          return _c(
            "custom-callout",
            { key: index, staticClass: "mt-2", attrs: { "has-toggle": false } },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 pl-5" }, [
                  _c("div", { staticClass: "divider-horizontal" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-2 custom-information-container" },
                        [
                          _c(
                            "div",
                            { staticClass: "custom-information-icon" },
                            [
                              _c("i", {
                                staticClass: "orange-icon fas fa-user-tie"
                              })
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "regular custom-information-title" },
                            [_vm._v("Nombre:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "regular custom-information",
                              staticStyle: { "text-transform": "capitalize" }
                            },
                            [
                              _c("b", [
                                _vm._v(_vm._s(item.evaluatorName.toLowerCase()))
                              ])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("custom-information", {
                            attrs: {
                              news: item.educ_New,
                              renovation: item.educ_Renew,
                              title: "Servicios Educativos"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("custom-information", {
                            attrs: {
                              news: item.serv_Relat_New,
                              renovation: item.serv_Relat_Renew,
                              title: "Servicios Relacionados"
                            }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col-2" }, [
                        _c(
                          "div",
                          { staticClass: "regular custom-information-total" },
                          [
                            _c("p", [_vm._v("Total:")]),
                            _c("p", { staticClass: "quantity" }, [
                              _vm._v(" " + _vm._s(item.total_Proposals) + " ")
                            ])
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]
          )
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }